import { LOAD_COMPANY_SUCCESS } from "../actions/company";


const initialState = {
  profile: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_COMPANY_SUCCESS:
      return { ...state, profile: action.payload };
    default:
      return state;
  }
}